export enum Errors {
  // Generic Errors
  GENERIC_ERROR = "generic_error",
  INTERNAL_SERVER_ERROR = "internal_server_error",
  INVALID_REQUEST_ERROR = "invalid_request_error",
  TOO_MANY_REQUESTS = "too_many_requests",
  INVALID_TYPE = "invalid_type",
  INVALID_JSON = "invalid_json",
  INVALID_UUID = "invalid_uuid",
  INVALID_COUNTRY = "invalid_country",
  INVALID_PHONE_NUMBER = "invalid_phone_number",
  INVALID_URL = "invalid_url",
  INVALID_OBJECT = "invalid_object",
  INVALID_DATE = "invalid_date",
  INVALID_NUMBER = "invalid_number",
  TIMEOUT = "timeout",
  ID_REQUIRED = "required_id",
  DATE_RANGE_INVALID = "date_range_invalid",
  DATE_IN_FUTURE = "date_in_future",
  DATE_RANGE_TOO_LONG = "date_range_too_long",
  IDENTIFIER_REQUIRED = "identifier_required",
  IDENTIFIER_ALREADY_EXISTS = "identifier_already_exists",
  FIELD_REQUIRED = "field_required",
  FIELD_MAX_LENGTH = "field_max_length",
  CONTENT_EXTRACTION_FAILED = "content_extraction_failed",
  MISSING_FILE_FIELD = "missing_file_field",
  ACTION_NOT_SCOPED = "action_not_scoped",
  // Auth
  ADMIN_ALREADY_EXISTS = "admin_already_exists",
  ADMIN_NOT_FOUND = "admin_not_found",
  EMAIL_INVALID = "email_invalid",
  EMAIL_NOT_CORPORATE = "email_not_corporate",
  EMAIL_REQUIRED = "required_email",
  EMPLOYEE_NOT_FOUND = "employee_not_found",
  LOGIN_CREDENTIALS_INVALID = "login_credentials_invalid",
  NAME_REQUIRED = "required_name",
  PASSWORD_INVALID = "invalid_password",
  WEAK_PASSWORD_USED = "weak_password_used",
  PASSWORD_MIN_LENGTH = "password_min_length",
  OLD_PASSWORD_INVALID = "old_password_invalid",
  PASSWORD_DONT_MATCH = "password_dont_match",
  PASSWORD_REQUIRED = "required_password",
  TOKEN_NOT_FOUND = "token_not_found",
  API_TOKEN_READ_ONLY = "api_token_read_only",
  UNAUTHORIZED = "unauthorized",
  ROLE_IS_REQUIRED = "role_is_required",
  WEBSITE_NOT_REACHABLE = "website_not_reachable",
  SETUP_TOKEN_NOT_FOUND = "setup_token_not_found",
  // Employees
  AVATAR_FILE_SIZE_EXCEEDED = "avatar_file_size_exceeded",
  EMPLOYEE_ALREADY_EXISTS = "employee_already_exists",
  EMPLOYEE_EMAIL_INVALID = "employee_email_invalid",
  EMPLOYEE_EMAIL_REQUIRED = "employee_email_required",
  EMPLOYEE_LOCALE_REQUIRED = "employee_locale_required",
  EMPLOYEE_NAME_REQUIRED = "employee_name_required",
  EMPLOYEE_PERMISSIONS_REQUIRED = "employee_permissions_required",
  EMPLOYEE_ALREADY_ARCHIVED = "employee_already_archived",
  EMPLOYEE_NOT_ARCHIVED = "employee_not_archived",
  CANNOT_ARCHIVE_YOURSELF = "cannot_archive_yourself",
  EMPLOYEE_ALREADY_OWNER = "employee_already_owner",
  INVITATION_ALREADY_SENT = "invitation_already_sent",
  INVITATION_NOT_FOUND = "invitation_not_found",
  INVITATION_TOKEN_NOT_FOUND = "invitation_token_not_found",
  LOCALE_REQUIRED = "locale_required",
  // Organizations
  ORGANIZATION_NOT_FOUND = "organization_not_found",
  ORGANIZATION_SLUG_ALREADY_EXISTS = "organization_slug_already_exists",
  ORGANIZATION_TYPE_INVALID = "organization_type_invalid",
  // Companies
  COMPANY_ALREADY_EXISTS = "company_already_exists",
  COMPANY_NAME_IS_REQUIRED = "company_name_is_required",
  COMPANY_NOT_FOUND = "company_not_found",
  VAULT_ENTRY_NOT_FOUND = "vault_entry_not_found",
  VAULT_KEY_INVALID = "vault_key_invalid",
  VAULT_SECRET_NOT_ALLOWED = "vault_secret_not_allowed",
  REFERRAL_LEAD_NOT_FOUND = "referral_lead_not_found",
  COMPANY_ID_REQUIRED = "company_id_required",
  ORGANIZATION_ID_REQUIRED = "organization_id_required",
  COMPANY_WITHOUT_OWNER = "company_without_owner",
  COMPANY_SLUG_ALREADY_EXISTS = "company_slug_already_exists",
  COMPANY_SIZE_REQUIRED = "company_size_required",
  COMPOSER_CUSTOM_PROMPT_INVALID = "composer_custom_prompt_invalid",
  // Billing
  ORGANIZATION_SUBSCRIPTION_NOT_FOUND = "organization_subscription_not_found",
  CREDITS_PACKAGE_NOT_FOUND = "credits_package_not_found",
  NO_PACKAGE_CREDITS_AVAILABLE = "no_package_credits_available",
  STRIPE_CUSTOMER_ID_REQUIRED = "stripe_customer_id_required",
  STRIPE_PRICE_NOT_FOUND = "stripe_price_not_found",
  CREDIT_TRANSACTION_NOT_FOUND = "credit_transaction_not_found",
  // Campaigns
  CAMPAIGN_INVALID = "campaign_invalid",
  CAMPAIGN_ID_REQUIRED = "campaign_id_required",
  CAMPAIGN_NOT_FOUND = "campaign_not_found",
  CAMPAIGN_NOT_ACTIVE = "campaign_not_active",
  CAMPAIGN_NOT_LAUNCHED = "campaign_not_launched",
  CAMPAIGN_STATUS_INVALID = "campaign_status_invalid",
  CAMPAIGN_GOAL_INVALID = "campaign_goal_invalid",
  CAMPAIGN_GOALS_REQUIRED = "campaign_goals_required",
  CAMPAIGN_GOAL_NOT_FOUND = "campaign_goal_not_found",
  CAMPAIGN_TEMPLATES_REQUIRED = "campaign_templates_required",
  CAMPAIGN_OPENING_MESSAGES_REQUIRED = "campaign_opening_messages_required",
  CAMPAIGN_TEMPLATE_NOT_FOUND = "campaign_template_not_found",
  CAMPAIGN_TRIGGER_INVALID = "campaign_trigger_invalid",
  CAMPAIGN_TRIGGER_NOT_FOUND = "campaign_trigger_not_found",
  CAMPAIGN_SCHEDULE_IN_PAST = "campaign_schedule_in_past",
  CAMPAIGN_LAUNCH_NOT_FOUND = "campaign_launch_not_found",
  CAMPAIGN_LAUNCH_NOT_SCHEDULED = "campaign_launch_not_scheduled",
  CAMPAIGN_CONDITION_INVALID = "campaign_condition_invalid",
  CAMPAIGN_ACTION_INVALID = "campaign_action_invalid",
  CAMPAIGN_EVENT_INVALID = "campaign_event_invalid",
  CAMPAIGN_EVENT_WITHOUT_ACTION = "campaign_event_without_action",
  WORKFLOW_IMPORT_INVALID_FILE = "workflow_import_invalid_file",
  CAMPAIGN_CHANNEL_REQUIRED = "campaign_channel_required",
  CAMPAIGN_DEFAULT_LANGUAGE_REQUIRED = "campaign_default_language_required",
  CAMPAIGN_DEFAULT_LANGUAGE_TEMPLATE_REQUIRED = "campaign_default_language_template_required",
  CAMPAIGN_ALREADY_ARCHIVED = "campaign_already_archived",
  CAMPAIGN_NOT_ARCHIVED = "campaign_not_archived",
  CAMPAIGN_NODE_NOT_FOUND = "campaign_node_not_found",
  CAMPAIGN_NODE_TYPE_NOT_FOUND = "campaign_node_type_not_found",
  CAMPAIGN_TRIGGER_QR_WITHOUT_QR = "campaign_trigger_qr_without_qr",
  CAMPAIGN_TRIGGER_INSTAGRAM_WITHOUT_ACCOUNT = "campaign_trigger_instagram_without_account",
  CAMPAIGN_TRIGGER_INSTAGRAM_INVALID_AUDIENCE = "campaign_trigger_instagram_invalid_audience",
  CAMPAIGN_TRIGGER_INSTAGRAM_INVALID_REPLY = "campaign_trigger_instagram_invalid_reply",
  CAMPAIGN_TRIGGER_MESSENGER_WITHOUT_PAGE = "campaign_trigger_messenger_without_page",
  CAMPAIGN_NUMBER_OR_INTEGRATION_ID_REQUIRED = "campaign_number_or_integration_id_required",
  CAMPAIGN_WHATSAPP_DEFAULT_IMMUTABLE = "campaign_whatsapp_default_immutable",
  CAMPAIGN_CHANNEL_GMAIL_WITHOUT_ACCOUNT = "campaign_channel_gmail_without_account",
  CAMPAIGN_CHANNEL_OUTLOOK_WITHOUT_ACCOUNT = "campaign_channel_outlook_without_account",
  CAMPAIGN_CALLBACK_URL_REQUIRED = "campaign_callback_url_required",
  CAMPAIGN_CALLBACK_URL_INVALID = "campaign_callback_url_invalid",
  CAMPAIGN_CALLBACK_URL_MISSING_REFERENCE_ID_MACRO = "campaign_callback_url_missing_reference_id_macro",
  // Clusters
  CLUSTER_SNAPSHOT_NOT_FOUND = "cluster_snapshot_not_found",
  CANONICAL_TOPIC_NOT_FOUND = "canonical_topic_not_found",
  // Goals
  GOAL_NOT_FOUND = "goal_not_found",
  GOAL_ASSISTANT_INSTRUCTIONS_REQUIRED = "goal_assistant_instructions_required",
  GOAL_OPTIONS_REQUIRED = "goal_options_required",
  GOAL_OPTIONS_MIN_REQUIRED = "goal_options_min_required",
  GOAL_OPTIONS_MAX_REQUIRED = "goal_options_max_required",
  GOAL_OPTIONS_NPS_REQUIRED = "goal_options_nps_required",
  CONVERSATION_GOAL_NOT_FOUND = "conversation_goal_not_found",
  GOAL_MEDIA_UPLOAD_ERROR = "goal_media_upload_error",
  GOAL_NAME_ALREADY_EXISTS = "goal_name_already_exists",
  // Conversations
  CONVERSATION_NOT_FOUND = "conversation_not_found",
  CONVERSATION_ALREADY_ACTIVE = "conversation_already_active",
  CONVERSATION_IS_NOT_TESTING = "conversation_is_not_testing",
  CONVERSATION_IS_NOT_CAMPAIGN = "conversation_is_not_campaign",
  CONVERSATION_ALREADY_HAS_MESSAGES = "conversation_already_has_messages",
  CONVERSATION_NOT_STARTED = "conversation_not_started",
  CONVERSATION_RESPONSE_NOT_FOUND = "conversation_response_not_found",
  CONVERSATION_OPPORTUNITY_NOT_FOUND = "conversation_opportunity_not_found",
  CONVERSATION_ORDER_ACTION_NOT_FOUND = "conversation_order_action_not_found",
  SHORT_LINK_NOT_FOUND = "short_link_not_found",
  // Customers
  CUSTOMER_NOT_FOUND = "customer_not_found",
  CUSTOMER_METADATA_INVALID = "customer_metadata_invalid",
  CUSTOMER_NAME_INVALID = "customer_name_invalid",
  CUSTOMER_PHONE_INVALID = "customer_phone_invalid",
  CUSTOMER_USES_CHANNEL = "customer_uses_channel",
  CUSTOMER_EMAIL_NOR_PHONE_FOUND = "customer_email_nor_phone_found",
  CUSTOMER_NOT_IN_MANUAL_CONTROL = "customer_not_in_manual_control",
  CUSTOMER_PHONE_NUMBER_REQUIRED = "customer_phone_number_required",
  CUSTOMER_WITH_PHONE_ALREADY_EXISTS = "customer_with_phone_already_exists",
  CUSTOMER_WITHOUT_EMAIL_OR_TENTATIVE_EMAIL = "customer_without_email_or_tentative_email",
  // Company Clients
  COMPANY_CLIENT_NOT_FOUND = "company_client_not_found",
  // S3
  S3_DOWNLOAD_ERROR = "s3_download_error",
  S3_NOT_CONFIGURED = "s3_not_configured",
  S3_UPLOAD_ERROR = "s3_upload_error",
  S3_UPLOAD_FILE_TYPE_INVALID = "s3_upload_file_type_invalid",
  // Messages
  MESSAGE_NOT_FOUND = "message_not_found",
  MESSAGE_IDENTIFIER_NOT_FOUND = "message_identifier_not_found",
  // Klaviyo
  KLAVIYO_INTEGRATION_NOT_FOUND = "klaviyo_integration_not_found",
  // Meta
  WHATSAPP_INTEGRATION_NOT_FOUND = "whatsapp_integration_not_found",
  WHATSAPP_TEMPLATE_NOT_FOUND = "whatsapp_template_not_found",
  WHATSAPP_TEMPLATE_ALREADY_EXISTS = "whatsapp_template_already_exists",
  WHATSAPP_TEMPLATE_ALREADY_PENDING = "whatsapp_template_already_pending",
  WHATSAPP_TEMPLATE_INVALID_TEMPLATE = "whatsapp_template_invalid_template",
  WHATSAPP_TEMPLATE_VARIABLE_AT_EDGE = "whatsapp_template_variable_at_edge",
  WHATSAPP_TEMPLATE_INVALID_VARIABLES = "whatsapp_template_invalid_variables",
  WHATSAPP_TEMPLATE_VARIABLE_NAME_INVALID = "whatsapp_template_variable_name_invalid",
  WHATSAPP_TEMPLATE_VARIABLE_EXAMPLE_REQUIRED = "whatsapp_template_variable_example_required",
  WHATSAPP_NUMBER_NOT_FOUND = "whatsapp_number_not_found",
  WHATSAPP_OPENING_MESSAGE_NOT_FOUND = "whatsapp_opening_message_not_found",
  WHATSAPP_EXCHANGE_TOKEN_ERROR = "whatsapp_exchange_token_error",
  WHATSAPP_SUBSCRIBED_APP_ERROR = "whatsapp_subscribed_app_error",
  WHATSAPP_DOWNLOAD_MEDIA_FAILED = "whatsapp_download_media_failed",
  WHATSAPP_PREPARE_MEDIA_FAILED = "whatsapp_prepare_media_failed",
  WHATSAPP_UPLOAD_MEDIA_FAILED = "whatsapp_upload_media_failed",
  WHATSAPP_MESSAGE_HANDLER_FAILED = "whatsapp_message_handler_failed",
  WHATSAPP_TEMPLATE_EDIT_24H = "whatsapp_template_edit_24h",
  WHATSAPP_ERROR_UPDATING_TEMPLATE = "whatsapp_error_updating_template",
  WHATSAPP_ERROR_VERIFYING_NUMBER = "whatsapp_error_verifying_number",
  // Sales Force
  SALES_FORCE_INTEGRATION_NOT_FOUND = "sales_force_integration_not_found",
  SALES_FORCE_KEYMAP_NOT_FOUND = "sales_force_keymap_not_found",
  // Dashboard
  ERROR_PROCESSING_CLUSTERS = "error_processing_clusters",
  // Knowledge Base
  KNOWLEDGE_BASE_ITEM_NOT_FOUND = "knowledge_base_item_not_found",
  KNOWLEDGE_BASE_ITEM_CONTENT_INVALID = "knowledge_base_item_content_invalid",
  KNOWLEDGE_BASE_UNSUPPORTED_FILE_FORMAT = "knowledge_base_unsupported_file_format",
  KNOWLEDGE_BASE_FILE_SIZE_EXCEEDED = "knowledge_base_file_size_exceeded",
  WEBPAGE_NOT_FOUND = "webpage_not_found",
  KNOWLEDGE_BASE_ITEM_ALREADY_EXISTS = "knowledge_base_item_already_exists",
  // Conversation Tickets & Questions
  CONVERSATION_TICKET_NOT_FOUND = "conversation_ticket_not_found",
  ISSUE_NOT_FOUND = "issue_not_found",
  CONVERSATION_QUESTION_NOT_FOUND = "conversation_question_not_found",
  LOGISTICS_TICKET_INTEGRATION_NOT_FOUND = "logistics_ticket_integration_not_found",
  // Shopify
  SHOPIFY_INTEGRATION_NOT_FOUND = "shopify_integration_not_found",
  SHOPIFY_INTEGRATION_INVALID = "shopify_integration_invalid",
  SHOPIFY_ORDER_NOT_FOUND = "shopify_order_not_found",
  SHOPIFY_ORDER_MISMATCH_EMAIL = "shopify_order_mismatch_email",
  SHOPIFY_ORDER_MISMATCH_CONTACT = "shopify_order_mismatch_contact",
  SHOPIFY_ORDER_MISMATCH_ID = "shopify_order_mismatch_id",
  SHOPIFY_CUSTOMER_ORDERs_NOT_FOUND = "shopify_customer_orders_not_found",
  SHOPIFY_CUSTOMER_NOT_FOUND = "shopify_customer_not_found",
  SHOPIFY_REFUND_ORDER_NOT_FOUND = "shopify_refund_order_not_found",
  SHOPIFY_REQUEST_ERROR = "shopify_request_error",
  SHOPIFY_REQUEST_PARSE_INVALID = "shopify_request_parse_invalid",
  SHOPIFY_CATALOG_SEARCH_ERROR = "shopify_catalog_search_error",
  SHOPIFY_PRODUCT_FETCH_ERROR = "shopify_product_fetch_error",
  SHOPIFY_UNAUTHORIZED = "shopify_unauthorized",
  SHOPIFY_LOCATIONS_ACCESS_DENIED = "shopify_locations_access_denied",
  SHOPIFY_SIZE_CHARTS_DISABLED = "shopify_size_charts_disabled",
  // Importers
  EXCEL_WORKBOOK_EMPTY = "excel_workbook_empty",
  EXCEL_WORKBOOK_INVALID_DATA = "excel_workbook_invalid_data",
  EXCEL_WORKBOOK_INVALID_FORMAT = "excel_workbook_invalid_format",
  CUSTOMER_IMPORT_NOT_FOUND = "customer_import_not_found",
  CUSTOMER_IMPORT_TOO_LARGE = "customer_import_too_large",
  // QRs
  QR_NOT_FOUND = "qr_not_found",
  QR_WITHOUT_CAMPAIGN = "qr_without_campaign",
  // Opening messages
  OPENING_MESSAGE_TEXT_NO_IDENTIFIER_VARIABLE = "opening_message_text_no_identifier_variable",
  // Segments
  SEGMENT_ALREADY_EXISTS = "segment_already_exists",
  SEGMENT_NOT_FOUND = "segment_not_found",
  SEGMENT_CUSTOMER_NOT_FOUND = "segment_customer_not_found",
  SEGMENT_GROUP_NOT_FOUND = "segment_group_not_found",
  SEGMENT_GROUP_ALREADY_EXISTS = "segment_group_already_exists",
  ONE_SEGMENT_RULE_REQUIRED = "one_segment_rule_required",
  // BigBlue
  BIGBLUE_REQUEST_ERROR = "bigblue_request_error",
  BIGBLUE_INTEGRATION_NOT_FOUND = "bigblue_integration_not_found",
  BIGBLUE_ORDER_NOT_FOUND = "bigblue_order_not_found",
  BIGBLUE_ORDER_MISMATCH_ID = "bigblue_order_mismatch_id",
  BIGBLUE_ORDER_MISMATCH_EMAIL = "bigblue_order_mismatch_email",
  // Reveni
  REVENI_INTEGRATION_NOT_FOUND = "reveni_integration_not_found",
  REVENI_RETURN_NOT_FOUND = "reveni_return_not_found",
  REVENI_RETURN_MISMATCH_EMAIL = "reveni_return_mismatch_email",
  REVENI_RETURN_MISMATCH_ID = "reveni_return_mismatch_id",
  REVENI_REQUEST_ERROR = "reveni_request_error",
  // LoopReturns
  LOOP_RETURNS_INTEGRATION_NOT_FOUND = "loop_returns_integration_not_found",
  LOOP_RETURNS_RETURN_NOT_FOUND = "loop_returns_return_not_found",
  LOOP_RETURNS_RETURN_MISMATCH_EMAIL = "loop_returns_return_mismatch_email",
  LOOP_RETURNS_RETURN_MISMATCH_ID = "loop_returns_return_mismatch_id",
  LOOP_RETURNS_REQUEST_ERROR = "loop_returns_request_error",
  // Rever
  REVER_INTEGRATION_NOT_FOUND = "rever_integration_not_found",
  REVER_RETURN_NOT_FOUND = "rever_return_not_found",
  REVER_RETURN_MISMATCH_EMAIL = "rever_return_mismatch_email",
  REVER_RETURN_MISMATCH_ID = "rever_return_mismatch_id",
  REVER_REQUEST_ERROR = "rever_request_error",
  // Zendesk
  ZENDESK_INTEGRATION_NOT_FOUND = "zendesk_integration_not_found",
  ZENDESK_INVALID_CREDENTIALS = "zendesk_invalid_credentials",
  ZENDESK_TOKEN_REQUIRED = "zendesk_token_required",
  ZENDESK_COMPANY_SUBDOMAIN_REQUIRED = "zendesk_company_subdomain_required",
  ZENDESK_SUBJECT_TITLE_REQUIRED = "zendesk_ticket_title_required",
  // Gorgias
  GORGIAS_INTEGRATION_NOT_FOUND = "gorgias_integration_not_found",
  GORGIAS_INVALID_CREDENTIALS = "gorgias_invalid_credentials",
  GORGIAS_SUBJECT_REQUIRED = "gorgias_subject_required",
  GORGIAS_BODY_REQUIRED = "gorgias_body_required",
  GORGIAS_BASE_API_URL_REQUIRED = "gorgias_base_api_url_required",
  GORGIAS_TOKEN_REQUIRED = "gorgias_token_required",
  GORGIAS_USERNAME_REQUIRED = "gorgias_username_required",
  // FrontApp
  FRONTAPP_INTEGRATION_NOT_FOUND = "frontapp_integration_not_found",
  FRONTAPP_INVALID_CREDENTIALS = "frontapp_invalid_credentials",
  FRONTAPP_SUBJECT_REQUIRED = "frontapp_subject_required",
  FRONTAPP_BODY_REQUIRED = "frontapp_body_required",
  FRONTAPP_TOKEN_REQUIRED = "frontapp_token_required",
  // Widget
  WIDGET_CONVERSATION_SLUG_NOT_FOUND = "widget_conversation_slug_not_found",
  WIDGET_BUBBLE_IMAGE_FILE_NOT_FOUND = "widget_bubble_image_file_not_found",
  WIDGET_IFRAME_BACKGROUND_IMAGE_FILE_NOT_FOUND = "widget_iframe_background_image_file_not_found",
  // CompanyIntegrationConfiguration
  COMPANY_INTEGRATION_CONFIGURATION_NOT_FOUND = "company_integration_configuration_not_found",
  COMPANY_INTEGRATION_CONFIGURATION_FIND_ORDER_DISABLED = "company_integration_configuration_find_order_disabled",
  COMPANY_INTEGRATION_CONFIGURATION_CHECK_RETURN_DISABLED = "company_integration_configuration_check_return_disabled",
  COMPANY_INTEGRATION_CONFIGURATION_CANCEL_ORDER_DISABLED = "company_integration_configuration_cancel_order_disabled",
  // Cancelled Orders
  CANCELLATION_REASON_REQUIRED = "cancellation_reason_required",
  // Insights
  INSIGHT_SIGNAL_NOT_FOUND = "insight_signal_not_found",
  INSIGHT_SIGNAL_EMPLOYEE_SOLUTION_NOT_FOUND = "insight_signal_employee_solution_not_found",
  // Instagram
  INSTAGRAM_INTEGRATION_NOT_FOUND = "instagram_integration_not_found",
  INSTAGRAM_PROFILE_NOT_FOUND = "instagram_profile_not_found",
  INSTAGRAM_ACCESS_TOKEN_ERROR = "instagram_access_token_error",
  INSTAGRAM_LONG_LIVED_ACCESS_TOKEN_ERROR = "instagram_long_lived_access_token_error",
  INSTAGRAM_REFRESH_TOKEN_ERROR = "instagram_refresh_token_error",
  INSTAGRAM_CAMPAIGN_NOT_FOUND = "instagram_campaign_not_found",
  INSTAGRAM_MEDIA_NOT_FOUND = "instagram_media_not_found",
  INSTAGRAM_ERROR_REPLY_COMMENT = "instagram_error_reply_comment",
  INSTAGRAM_SUBSCRIBE_APP_ERROR = "instagram_subscribed_app_error",
  INSTAGRAM_NO_ACCOUNTS = "instagram_no_accounts",
  // Messenger
  MESSENGER_INTEGRATION_NOT_FOUND = "messenger_integration_not_found",
  MESSENGER_NO_PAGES = "messenger_no_pages",
  MESSENGER_SUBSCRIBE_APP_ERROR = "messenger_subscribed_app_error",
  MESSENGER_ERROR_REPLY_COMMENT = "messenger_error_reply_comment",
  // Meta
  META_EXCHANGE_TOKEN_ERROR = "meta_exchange_token_error",
  // Change Log
  CHANGE_LOG_NOT_FOUND = "change_log_not_found",
  // Capabilities
  CAPABILITY_NOT_FOUND = "capability_not_found",
  CAPABILITY_CONFIG_INVALID = "capability_config_invalid",
  CAPABILITY_NOT_AVAILABLE = "capability_not_available",
  CAPABILITY_ALREADY_INSTALLED = "capability_already_installed",
  CAPABILITY_CANNOT_BE_ENABLED = "capability_cannot_be_enabled",
  CAPABILITY_EXECUTION_NOT_FOUND = "capability_execution_not_found",
  // MCP Capabilities
  MCP_CONNECTION_FAILED = "mcp_connection_failed",
  MCP_EXECUTION_TIMEOUT = "mcp_execution_timeout",
  MCP_TOOL_EXECUTION_FAILED = "mcp_tool_execution_failed",
  MCP_TOOL_NOT_FOUND = "mcp_tool_not_found",
  MCP_INVALID_AUTH = "mcp_invalid_auth",
  // Amphora
  AMPHORA_INTEGRATION_NOT_FOUND = "amphora_integration_not_found",
  AMPHORA_INTEGRATION_INVALID = "amphora_integration_invalid",
  AMPHORA_ORDER_NOT_FOUND = "amphora_order_not_found",
  AMPHORA_ORDER_NO_EMAIL = "amphora_order_no_email",
  AMPHORA_ORDER_MISMATCH_EMAIL = "amphora_order_mismatch_email",
  AMPHORA_ORDER_MISMATCH_ID = "amphora_order_mismatch_id",
  AMPHORA_REQUEST_ERROR = "amphora_request_error",
  AMPHORA_REQUEST_PARSE_INVALID = "amphora_request_parse_invalid",
  AMPHORA_TICKET_NOT_FOUND = "amphora_ticket_not_found",
  AMPHORA_CUSTOMER_CANNOT_BE_CONTACTED = "amphora_customer_cannot_be_contacted",
  AMPHORA_OWN_WHATSAPP_REQUIRED = "amphora_own_whatsapp_required",
  AMPHORA_LOGISTICS_LANGUAGES_REQUIRED = "amphora_logistics_languages_required",
  AMPHORA_LOGISTICS_WHATSAPP_NUMBER_REQUIRED = "amphora_logistics_whatsapp_number_required",
  // Backoffice
  BACKOFFICE_SCHEDULED_REPORT_NOT_FOUND = "backoffice_scheduled_report_not_found",
  BACKOFFICE_SCHEDULED_REPORT_ALIAS_ALREADY_EXISTS = "backoffice_scheduled_report_alias_already_exists",
  // Google Sheets
  GOOGLE_SHEETS_MISSING_PERMISSIONS = "google_sheets_missing_permissions",
  GOOGLE_SHEETS_ERROR_WRITING = "google_sheets_error_writing",
  GOOGLE_SHEETS_RANGE_NOT_FOUND = "google_sheets_range_not_found",
  // Notes
  NOTE_NOT_FOUND = "note_not_found",
  NOTE_MENTION_NOT_FOUND = "note_mention_not_found",
  // Gmail integration
  GMAIL_INTEGRATION_NOT_FOUND = "gmail_integration_not_found",
  GMAIL_INTEGRATION_ERROR_GENERATING_TOKENS = "gmail_integration_error_generating_tokens",
  GMAIL_INTEGRATION_MISSING_SCOPES = "gmail_integration_missing_scopes",
  GMAIL_USERINFO_NO_EMAIL = "gmail_userinfo_no_email",
  GMAIL_TOKEN_REFRESH_FAILED = "gmail_token_refresh_failed",
  GMAIL_CAMPAIGN_RELATION_NOT_FOUND = "gmail_campaign_relation_not_found",
  // Outlook integration
  OUTLOOK_INTEGRATION_NOT_FOUND = "outlook_integration_not_found",
  OUTLOOK_INTEGRATION_ERROR_GENERATING_TOKENS = "outlook_integration_error_generating_tokens",
  OUTLOOK_INTEGRATION_MISSING_SCOPES = "outlook_integration_missing_scopes",
  OUTLOOK_USERINFO_NO_EMAIL = "outlook_userinfo_no_email",
  OUTLOOK_TOKEN_REFRESH_FAILED = "outlook_token_refresh_failed",
  OUTLOOK_GRAPH_REQUEST_FAILED = "outlook_graph_request_failed",
  CAMPAIGN_FLOW_REQUIRED = "campaign_flow_required",
}
